import React from 'react'
import type {CategoryData} from '../data/types'

interface SpendBySizeProps {
  data: CategoryData
}

const SpendBySize: React.FC<SpendBySizeProps> = ({data}) => (
  <section className="section light">
    <div className="wrap">
      <div className="subsection">
        <div className="sub-eyebrow">By company size</div>
        <h3>
          What {data.label}-buying companies spend
          <br />
          each month, by size.
        </h3>
        <p className="sub-intro">
          The average {data.label} bill at each tier, drawn from the full leaderboard above, not a single vendor.
        </p>
        <div className="size-cards">
          {data.spendBySize.map((s) => {
            const [head, range] = s.range.split(' · ')
            return (
              <div key={s.range} className="size-card">
                <div className="head">{head}</div>
                <div className="size-range">{range || head}</div>
                <div className="big-val">
                  {s.spend}
                  <span className="unit">/ month</span>
                </div>
                <div className="big-label">{s.subLabel}</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  </section>
)

export default SpendBySize
